export default __webpack_public_path__ + "static/step_05-441dfd0d9e637050cc950c23b387099a.png";